var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreyFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33329 13.6668C1.87496 13.6668 1.48274 13.5038 1.15663 13.1777C0.829959 12.851 0.666626 12.4585 0.666626 12.0002V2.00016C0.666626 1.54183 0.829959 1.14961 1.15663 0.823496C1.48274 0.496829 1.87496 0.333496 2.33329 0.333496H7.33329L8.99996 2.00016H15.6666C16.125 2.00016 16.5175 2.1635 16.8441 2.49016C17.1702 2.81627 17.3333 3.2085 17.3333 3.66683V12.0002C17.3333 12.4585 17.1702 12.851 16.8441 13.1777C16.5175 13.5038 16.125 13.6668 15.6666 13.6668H2.33329ZM2.33329 2.00016V12.0002H15.6666V3.66683H8.31246L6.64579 2.00016H2.33329Z",
    fill: "#82858D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFolder);
export default __webpack_public_path__ + "static/media/grey-folder.f6afedb04354afba98b982484ff75590.svg";
export { ForwardRef as ReactComponent };